import Alert from "th/alert";

export { Alert };

customElements.define("th-alert", Alert.CustomElementConstructor);
